import { render, staticRenderFns } from "./FeedbackWidget.vue?vue&type=template&id=2b48cdb2&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=ts"
export * from "./FeedbackWidget.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackWidget.vue?vue&type=style&index=0&id=2b48cdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48cdb2",
  null
  
)

export default component.exports